export default __webpack_public_path__ + "static/avatar-dont-2-87f2b2addf8a19795ac24cc77d39a625.png";